import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TopServiceSteps',
  setup(__props) {

/**
 * トップの「ヤギッシュのサービス」3ステップ帯。
 *
 * Top.vue（1,700行超）の分解で切り出した。文言も画像もこの中に直書きの静的ブロックで、
 * script から触るものは無い。
 */

return { __sfc: true, }
}

})